import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap"; 
import { useLocation } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function AboutWhyMarquis({ id, scrollToSection, data }) { 

  const location = useLocation();
  
    useEffect(() => {
      // Handle scrolling to this section if the hash matches
      if (location.hash.replace("#", "") === id && scrollToSection) {
        scrollToSection();
      }
    }, [location.hash, id, scrollToSection]);  

  const descriptions = data.description
    ? JSON.parse(data.description)
    : [];

  return ( 
      <section className="about-identity-sec" id={id}>
        <Container fluid>
          <Row className="banner-text-center">
            <Col md={6}>
              <div className="heading-div">
                <h2 className="common-head darkGrey" data-aos="fade-up">
                  {data.title}
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="about-our-identity-row">
            <Col md={6}>             
                <img
                  src={`${apiUrl.apiUrl}/${data.first_image}`}
                  className="img-fluid"
                  alt="Marquis Property Developer"
                  data-aos="fade-up"
                />              
            </Col>

            <Col md={6}>
              <div className="about-investing-content-div" data-aos="fade-left">                
                  <img
                    src={`${apiUrl.apiUrl}/${data.second_image}`}
                    className="img-fluid mb-3"
                    alt="Marquis Real Estate Developer"
                  />               
                {descriptions.map((description, index) => (
                  <p className="common-para" key={index}>{descriptions[index]}</p>
                ))}
              </div>
            </Col>
          </Row>
        </Container>
      </section> 
  );
}
export default AboutWhyMarquis;
